/**
 * comment-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Comment, CommentType } from "../../../intake-form/comment";
import { validateAs, validateFor, validateOpaqueID, validateTSEnum }
    from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

@validateFor(MessageTag.RSP_COMMENT)
export class CommentResponse extends IncomingMessage
{
    @validateTSEnum(CommentType)
    public commentType : CommentType;

    @validateOpaqueID(true) // TODO: conditionally optional
    public commentId : number;

    @validateOpaqueID(true) // TODO: conditionally optional
    public stepId : number;

    @validateAs(
      {array: "object"},
      false,
      undefined,
      [
        (json : any) => json.comments = json.comments.map(
          (c : Comment) => Comment.fromData(c))
      ]
    )
    public comments : Comment[];
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/collaboration/comment-response.ts